import { ChangeDetectionStrategy, Component, HostBinding, input } from "@angular/core";

@Component({
    selector: "lg-ordered-item-menu",
    styleUrls: ["./lg-ordered-item-menu.component.scss"],
    template: `<ng-content />`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LgOrderedItemMenuComponent {
    readonly isOpen = input.required<boolean>();

    @HostBinding("class.ordered-item-selector-menu--open") get menuOpenedClass(): boolean {
        return this.isOpen();
    }
}
